import { ModalContext } from "app/app";
import axios from "axios";
import { FieldInput } from "components/fieldInput";
import { ViewContext } from "components/lib";
import { Form, Formik } from "formik";
import { Fragment, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import Loader from "./images/loader.gif";
import PageLoader from "./images/page_loader.gif";
import styles from "./styles.module.scss";

export function PullPolicyModal(props) {
  const { id } = useParams();
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);

  const validationSchema = Yup.object().shape({
    submission_number: Yup.string().required("This field is required!"),
  });

  async function runAPI() {
    if (
      modal.data &&
      modal.data.agency_id &&
      modal.name === "pull_policy_modal"
    ) {
      setLoading(true);

      await axios
        .get(`/api/company/list/all?account_id=${modal.data.agency_id}`)
        .then(async (res) => {
          setLoading(false);
          setCompanies(
            res.data.data.map((company) => {
              return { value: company.id, label: company.name };
            })
          );
        })
        .catch((err) => {
          setLoading(false);

          context.notification.show(
            "Failed to load table data",
            "error",
            true,
            "toast",
            "x-circle"
          );
        });
    }
  }

  useEffect(() => {
    runAPI();
  }, [modal]);

  return (
    <Fragment>
      {modal.name === "pull_policy_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            {loading ? (
              <img
                src={PageLoader}
                alt="loader"
                style={{ width: 20, marginTop: 170, marginBottom: 170 }}
              />
            ) : (
              <div className={styles.insideWrapper}>
                <div className={styles.title}>Add Document</div>
                <div className={styles.line} />
                <Formik
                  validationSchema={validationSchema}
                  initialValues={{
                    company: companies.length > 0 ? companies[0].value : "",
                    submission_number: "",
                  }}
                  onSubmit={async (values, { setErrors }) => {
                    const body = {
                      company_id: values.company,
                      account_id: id,
                      submission_number: values.submission_number,
                    };

                    setLoading(true);

                    await axios
                      .post(`/api/company_policy`, body)
                      .then(() => {
                        setLoading(false);

                        context.notification.show(
                          "Policy pushed successfully!",
                          "success",
                          true,
                          "toast",
                          "check-circle"
                        );

                        setModal({});
                      })
                      .catch((err) => {
                        setLoading(false);

                        context.notification.show(
                          err.response.data.message,
                          "error",
                          false,
                          "toast",
                          "x-circle"
                        );

                        setModal({});
                      });
                  }}
                >
                  {({
                    errors,
                    touched,
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    submitForm,
                  }) => (
                    <Fragment>
                      <Form className={styles.form} onSubmit={handleSubmit}>
                        <div
                          className={styles.fieldRow}
                          style={{ paddingBottom: 0 }}
                        >
                          <FieldInput
                            id="submission_number"
                            type="text"
                            label="Submission Number"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            required
                            showErrors
                            errors={errors.submission_number}
                            touched={touched.submission_number}
                          />
                        </div>
                        <div
                          className={styles.fieldRow}
                          style={{ paddingBottom: 0 }}
                        >
                          <FieldInput
                            id="company"
                            type="select"
                            label="Company"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            required
                            options={companies}
                            showErrors
                            errors={errors.company}
                            touched={touched.company}
                          />
                        </div>
                      </Form>
                      <div
                        className={styles.footer}
                        style={{ justifyContent: "flex-end" }}
                      >
                        <div className={styles.buttons}>
                          <button
                            className={styles.cancel}
                            onClick={() => setModal("")}
                          >
                            Cancel
                          </button>
                          <button
                            className={styles.save}
                            onClick={!loading ? submitForm : null}
                            style={
                              !loading
                                ? { cursor: "pointer" }
                                : { cursor: "default" }
                            }
                          >
                            {loading ? (
                              <img
                                src={Loader}
                                alt="Loader"
                                className={styles.loader}
                              />
                            ) : (
                              <>Pull</>
                            )}
                          </button>
                        </div>
                      </div>
                    </Fragment>
                  )}
                </Formik>
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
}
